import classNames from 'classnames';
import React from 'react';
import { ReactComponent as IconBroadcast } from '../../../../../assets/images/icons/icon_broadcast.svg';
import { ReactComponent as IconCompact } from '../../../../../assets/images/icons/icon_compact.svg';
import { ReactComponent as IconDrip } from '../../../../../assets/images/icons/icon_drip.svg';
import { ReactComponent as IconLte } from '../../../../../assets/images/icons/icon_lte.svg';
import { ReactComponent as IconReinforced } from '../../../../../assets/images/icons/icon_reinforced.svg';
import { ReactComponent as IconLightning } from '../../../../../assets/images/icons/icon_lightning.svg';
import styles from '../../../ProductDetails.module.scss';
import { ValueProp } from './index';

export function getWhatsNewValueProps(t: (key: string) => string): ValueProp[] {
  return [
    {
      icon: <IconCompact />,
      text: (
        <div className={classNames(styles.valueProp, styles.valuePropCheat)}>
          <span className={styles.valuePropHeader}>{t('fifty_percent_smaller')}</span>{' '}
          <span className={styles.valuePropBody}>{t('light_comfortable_for_dogs_of_all_sizes')}</span>
        </div>
      ),
    },
    {
      icon: <IconBroadcast />,
      text: (
        <div className={classNames(styles.valueProp, styles.valuePropCheat)}>
          <span className={styles.valuePropBadge}>{t('new')}</span>{' '}
          <span className={styles.valuePropHeader}>{t('real_time_live_gps_tracking_when_your_dog_is_lost')}</span>
        </div>
      ),
    },
    {
      icon: <IconLte />,
      text: (
        <div className={styles.valueProp}>
          <span className={styles.valuePropHeader}>{t('two_hundred_percent_lte_signal')}</span>{' '}
          <span className={styles.valuePropBody}>{t('track_in_most_remote_areas_and_on_hikes')}</span>
        </div>
      ),
    },
    {
      icon: <IconReinforced />,
      text: (
        <div className={styles.valueProp}>
          <span className={styles.valuePropHeader}>{t('five_hundred_lbs_plus_resistance')}</span>{' '}
          <span className={styles.valuePropBody}>{t('handles_the_worst_chewers_and_pullers')}</span>
        </div>
      ),
    },
    {
      icon: <IconDrip />,
      text: (
        <div className={styles.valueProp}>
          <span className={styles.valuePropHeader}>{t('ip68_ip66k')}</span>{' '}
          <span className={styles.valuePropBody}>{t('more_waterproof_than_ever_before')}</span>
        </div>
      ),
    },
    {
      icon: <IconLightning />,
      text: (
        <div className={styles.valueProp}>
          <span className={styles.valuePropHeader}>{t('up_to_3_months_battery_life_from_one_charge')}</span>
        </div>
      ),
    },
  ];
}
